import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { MessageCircle } from "lucide-react";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import PropertyDetail from "./pages/PropertyDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import AdminCrm from "./pages/AdminCrm";
import AdminTeam from "./pages/AdminTeam";
import AdminAgenda from "./pages/AdminAgenda";
import AdminDashboard from "./pages/AdminDashboard";
import AdminFinanceiro from "./pages/AdminFinanceiro";
import AdminSite from "./pages/AdminSite";
import AdminBrokerApp from "./pages/AdminBrokerApp";
import AdminAgendaEquipe from "./pages/AdminAgendaEquipe";

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/imovel/:id" element={<PropertyDetail />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/crm" element={<AdminCrm />} />
        <Route path="/admin/equipe" element={<AdminTeam />} />
        <Route path="/admin/agenda" element={<AdminAgenda />} />
        <Route path="/admin/agenda-equipe" element={<AdminAgendaEquipe />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/financeiro" element={<AdminFinanceiro />} />
        <Route path="/admin/site" element={<AdminSite />} />
        <Route path="/admin/app" element={<AdminBrokerApp />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && (
        <a
          href="https://wa.me/5534999236969?text=Ol%C3%A1!%20Quero%20falar%20com%20a%20Seed%20Im%C3%B3veis."
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
          data-testid="whatsapp-float"
          className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-seed-vivid text-seed-deep shadow-xl transition-transform duration-300 hover:scale-110"
        >
          <MessageCircle size={24} strokeWidth={2.5} />
        </a>
      )}
      <Toaster position={isAdmin ? "bottom-right" : "top-center"} richColors />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-seed-off" data-testid="app-root">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
